/**
  * @description 广告活动的下拉选择控件
*/
<template>
    <gj-virtual-select-more
        v-bind="$attrs"
        v-on="$listeners"
        clearable
        type="multi-check"
        :filterable="false"
        :width="width"
        :list="options"
        :loading="loading"
        :placeholder="placeholder"
        @change="changeValue"
    >
    </gj-virtual-select-more>
</template>

<script>
import {  SB, SP,  SD, } from "@/api/ad.js";
export default {
  name: "ad-campaign-select",
  props: {
    // 广告类型
    adType: {
      type: String,
      required: true,
      validator: function (value) {
        return ['SB', 'SD', 'SP'].indexOf(value) !== -1
      }
    },
    placeholder: {
      type: String,
      default: "广告活动"
    },
    width: {
      type: String,
      default: "180px"
    },
    // 站点list
    marketId: {
      type: String | Number,
      default: null
    },
    // 广告组合id
    portfolioId: {
      type: String | Number,
      default: null
    }
  },
  data() {
    return {
      options: [],
    };
  },
  components: {},
  watch: {
    marketId() {
      this.getOptions(this.adType)
    },
    portfolioId() {
      this.getOptions(this.adType)
    }
  },
  methods: {
    // 获取下拉选项
    async getOptions(type) {
      if (this.loading) return false
      this.loading = true
      const types = {
        SB: () => {
          return SB.selectSbCampaigns
        },
        SD: () => {
          return SD.selectSdCampaigns
        },
        SP: () => {
          return SP.selectSpCampaigns
        },
      }
      try {
        let params = {
          marketId: this.marketId,
          portfolioIds: this.portfolioId && [ this.portfolioId ],
        }
        let { data } = await types[type]()(params)
        this.options = (data || []).map(e => ({
          ...e,
          id: e.campaignId,
          text: e.campaignName
        }))
      } finally {
        this.loading = false
      }
      this.$emit('ok');
    },
    changeValue(val) {
      this.$emit('input', val);
    }
  },
  created() {
    this.getOptions(this.adType)
  },
};
</script>

<style scoped lang='scss'>
</style>